export const ADD_NEW_FEE_PROVIDER = 'ADD_NEW_FEE_PROVIDER';

export const ATTORNEY_COMPANY_TYPE = 'Attorney';
